import { connect } from 'react-redux';
import Campaign from '../components/landing/Campaign';
import actions from '../redux/actions/campaign';

const mapStateToProps = (state) => ({
  campaigns: state.campaign.campaign,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllCampaignAction: (params) => {
    dispatch(actions.fetchAllCampaignAction(params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Campaign);
